import script from "./recovery.vue?vue&type=script&setup=true&lang=js"
export * from "./recovery.vue?vue&type=script&setup=true&lang=js"

import "./recovery.vue?vue&type=style&index=0&id=ed60cd4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed60cd4a"]])

export default __exports__